export default __webpack_public_path__ + "926a08fb27e3303c7452b0bdd2d5e5ab.ttf";